Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useBreakpoints = void 0;
var _react = require("react");
var _useWindowDimensions2 = require("../../../utils/useWindowDimensions");
var _reactNative = require("react-native-web");
var _baseSize = require("../../baseSize");
var viewports = {
  mobile_xs: 16.24375,
  mobile_s: 19.99375,
  mobile_normal: 23.43125,
  mobile_m: 26.55625,
  mobile_l: 39.99375,
  mobile_xl: 47.99375,
  tablet: 63.99375,
  desktop_s: 74.99375,
  desktop_normal: 89.99375
};
var useBreakpoints = exports.useBreakpoints = function useBreakpoints() {
  var _useWindowDimensions = (0, _useWindowDimensions2.useWindowDimensions)(),
    width = _useWindowDimensions.width;
  var _remWidth = (0, _react.useMemo)(function () {
    var _window, _window$document;
    var _width = width / _baseSize.baseSize / _reactNative.PixelRatio.getFontScale();
    if (_reactNative.Platform.OS === 'web' && (_window = window) != null && (_window$document = _window.document) != null && _window$document.documentElement) {
      _width = width / parseFloat(window.getComputedStyle(window.document.documentElement, null).getPropertyValue('font-size'));
    }
    return _width;
  }, [width]);
  var bp = {
    is: function is(sizes) {
      return sizes.includes(true);
    },
    not: function not(sizes) {
      return !sizes.includes(true);
    },
    gt: function gt(viewport) {
      return _remWidth > viewport;
    },
    lt: function lt(viewport) {
      return _remWidth < viewport;
    },
    mobile_xs: _remWidth <= viewports.mobile_xs,
    mobile_s: _remWidth > viewports.mobile_xs && _remWidth <= viewports.mobile_s,
    mobile_normal: _remWidth > viewports.mobile_s && _remWidth <= viewports.mobile_normal,
    mobile_m: _remWidth > viewports.mobile_normal && _remWidth <= viewports.mobile_m,
    mobile_l: _remWidth > viewports.mobile_m && _remWidth <= viewports.mobile_l,
    mobile_xl: _remWidth > viewports.mobile_l && _remWidth <= viewports.mobile_xl,
    tablet: _remWidth > viewports.mobile_xl && _remWidth <= viewports.tablet,
    desktop: _remWidth > viewports.tablet,
    desktop_s: _remWidth > viewports.tablet && _remWidth <= viewports.desktop_s,
    desktop_normal: _remWidth > viewports.desktop_s && _remWidth <= viewports.desktop_normal,
    desktop_m: _remWidth > viewports.desktop_normal
  };
  return {
    bp: bp,
    viewports: viewports
  };
};